export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'eefe9bad-9163-4216-8c05-b0ec65a5496a';
export const MODAL_CLOSE_SEC = 2.5;
